import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";

export default function PageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/api/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setMissing(true));
  }, [slug]);

  if (missing) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-24 text-center" data-testid="page-not-found">
        <h1 className="font-display text-3xl font-semibold">Page not found</h1>
        <Link to="/"><Button variant="outline" className="mt-6 rounded-full">Go home</Button></Link>
      </div>
    );
  }
  if (!page) return <div className="flex min-h-[50vh] items-center justify-center text-muted-foreground">Loading…</div>;

  return (
    <div className="mx-auto max-w-3xl px-4 py-14" data-testid="page-view">
      <h1 className="font-display text-4xl font-semibold sm:text-5xl" data-testid="page-title">{page.title}</h1>
      <div className="mt-6 whitespace-pre-line text-base leading-relaxed text-foreground" data-testid="page-content">
        {page.content}
      </div>
    </div>
  );
}
